import style from './KnowYourCustomer.css';
import MainImage from '../../assets/images/kyc-card-sample.webp';
import BlurryId from '../../assets/images/blurry.webp';
import CroppedId from '../../assets/images/cropped.webp';
import ReflectedId from '../../assets/images/reflection.webp';
import Title from '../../components/shared/Typography/Title';
import AppBar from '../../components/shared/AppBar/AppBar';
import Button from '../../components/shared/Button/Button';
import useTranslation from '../../localization/i18n.context';
import { MicroBlinkEvent } from '../../sdk/microblink.event';
import { PermissionsEvent } from '../../sdk/permissions.event';
import NavigationUtils from '../../utils/navigation.utils';
import { TrackingEvent } from '../../sdk/tracking.event';
import usePermissionCheck from '../../hooks/permission.listener.hook';

const info = [
  {
    image: CroppedId,
    text: "Don't crop",
  },
  {
    image: BlurryId,
    text: 'Not blurry',
  },
  {
    image: ReflectedId,
    text: 'No reflection',
  },
];
const PopupType = {
  EXIT: 'exit',
  PERMISSION: 'permission',
};

export default function KnowYourCustomerView({
  onCloseClick,
  onBackClick,
  backRef = null,
  closeRef = null,
}) {
  const { t } = useTranslation();

  const onPermissionResponse = (data, times) => {
    const { status } = data;

    if (
      status === PermissionsEvent.Status.ASK_AGAIN &&
      times < PermissionsEvent.PermissionMaxRequestTimes
    ) {
      return PermissionsEvent.check(
        PermissionsEvent.Resources.CAMERA,
        PermissionsEvent.Action.ASK,
      );
    }

    if (status === PermissionsEvent.Status.GRANTED) {
      return MicroBlinkEvent.open();
    }

    return NavigationUtils.navigate(NavigationUtils.Routes.KYC, false, {
      popup: PopupType.PERMISSION,
    });
  };

  usePermissionCheck(onPermissionResponse, PermissionsEvent.Resources.CAMERA);

  return (
    <div className={style.main}>
      <AppBar
        onBackClick={onBackClick}
        onCloseClick={onCloseClick}
        backRef={backRef}
        closeRef={closeRef}
        title={t('ID Verification')}
        className="fixed-bar"
      />

      <div className={style.content}>
        <div className={style['kyc-image']}>
          <img src={MainImage} width={160} height={160} />
        </div>

        <div className={style['kyc-title']}>
          <Title
            text={t('Take a picture of the front and back of your ID')}
            className="text-center"
          />
        </div>

        <div className={style['kyc-info']}>
          {info.map(el => (
            <div className={style['info-block']} key={el.text}>
              <img src={el.image} width={80} height={80} />
              <span className={style['info-text']}>{t(el.text)}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="fixed-cta">
        <Button
          onClick={() => {
            TrackingEvent.trigger(
              TrackingEvent.Events.ONBOARDING_CONTINUE_BUTTON_TAP,
              TrackingEvent.Sources.CAAS,
              { step: KnowYourCustomerView.EventName },
            );

            PermissionsEvent.check(
              PermissionsEvent.Resources.CAMERA,
              PermissionsEvent.Action.ASK,
            );
          }}
          fullWidth
        >
          {t('Continue')}
        </Button>
      </div>
    </div>
  );
}
KnowYourCustomerView.EventName = 'onboarding_instructions';
KnowYourCustomerView.PopupType = PopupType;
